/* PARALIA · colección y búsqueda (sections/pa-collection.liquid, pa-search-results.liquid).
   Filtros, orden, chips y pestañas se actualizan con fetch + Section Rendering API (?section_id=) y history.replaceState.
   Sin JS todo funciona con formularios GET y enlaces normales. «Cargar más» pide la página siguiente y agrega las tarjetas. */
(() => {
  const ready = fn => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());

  class PaCollection {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.ctrl = null;
      root.classList.add('is-js');
      root.addEventListener('change', e => this.onChange(e));
      root.addEventListener('submit', e => this.onSubmit(e));
      root.addEventListener('click', e => this.onClick(e));
      root.addEventListener('toggle', e => this.onToggle(e), true);
      document.addEventListener('click', e => { if (!e.target.closest('[data-pa-col-pop]')) this.closePops(); });
      document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const open = this.root.querySelector('[data-pa-col-pop][open]');
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      });
    }

    closePops(except) {
      this.root.querySelectorAll('[data-pa-col-pop][open]').forEach(d => { if (d !== except) d.open = false; });
    }

    onToggle(e) {
      const d = e.target;
      if (d.matches && d.matches('[data-pa-col-pop]') && d.open) this.closePops(d);
    }

    /* URL a partir de un formulario de filtros (y el orden elegido). */
    urlFromForm(form) {
      const params = new URLSearchParams();
      for (const [k, v] of new FormData(form).entries()) {
        if (v === '' || k.startsWith('pa_')) continue;
        params.append(k, v);
      }
      const sort = this.root.querySelector('[data-pa-col-sort]');
      if (sort) params.set('sort_by', sort.value);
      const base = form.getAttribute('action') || window.location.pathname;
      const qs = params.toString();
      return qs ? `${base}?${qs}` : base;
    }

    onChange(e) {
      const t = e.target;
      if (t.matches('[data-pa-col-sort]')) {
        const form = this.root.querySelector('#PaColBar-' + this.sectionId) || this.root.querySelector('[data-pa-col-form]');
        if (form) return this.load(this.urlFromForm(form));
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', t.value);
        params.delete('page');
        return this.load(`${window.location.pathname}?${params}`);
      }
      const form = t.closest('[data-pa-col-form]');
      if (!form) return;
      if (t.matches('[data-pa-col-bucket]')) {
        const group = t.closest('[data-pa-col-buckets]');
        group.querySelectorAll('[data-pa-col-bucket]').forEach(b => { if (b !== t) b.checked = false; });
        const min = group.querySelector('[data-pa-col-min]');
        const max = group.querySelector('[data-pa-col-max]');
        if (min) min.value = t.checked ? t.dataset.gte : '';
        if (max) max.value = t.checked ? t.dataset.lte : '';
      }
      if (t.matches('[data-pa-col-min], [data-pa-col-max]')) {
        clearTimeout(this.rangeTimer);
        this.rangeTimer = setTimeout(() => this.load(this.urlFromForm(form)), 500);
        return;
      }
      this.load(this.urlFromForm(form));
    }

    onSubmit(e) {
      const form = e.target.closest('[data-pa-col-form]');
      if (!form) return;
      e.preventDefault();
      this.load(this.urlFromForm(form));
    }

    onClick(e) {
      const link = e.target.closest('[data-pa-col-link]');
      if (link) { e.preventDefault(); this.load(link.href); return; }
      const more = e.target.closest('[data-pa-col-more]');
      if (more) { e.preventDefault(); this.loadMore(more); return; }
      const top = e.target.closest('[data-pa-col-top]');
      if (top) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const h1 = document.querySelector('h1');
        if (h1) { h1.setAttribute('tabindex', '-1'); h1.focus({ preventScroll: true }); }
      }
    }

    sectionUrl(url) {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', this.sectionId);
      return u.toString();
    }

    async fetchDoc(url) {
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      const res = await fetch(this.sectionUrl(url), { signal: this.ctrl.signal });
      if (!res.ok) throw new Error(res.status);
      return new DOMParser().parseFromString(await res.text(), 'text/html');
    }

    async load(url) {
      const results = this.root.querySelector('[data-pa-col-region="results"]');
      results && results.classList.add('is-loading');
      try {
        const doc = await this.fetchDoc(url);
        this.swap(doc);
        const clean = new URL(url, window.location.origin);
        clean.searchParams.delete('section_id');
        clean.searchParams.delete('page');
        history.replaceState({}, '', clean.pathname + clean.search);
      } catch (err) {
        if (err.name === 'AbortError') return;
        window.location.href = url;
      } finally {
        const r = this.root.querySelector('[data-pa-col-region="results"]');
        r && r.classList.remove('is-loading');
      }
    }

    /* Reemplaza solo las regiones marcadas, para no cerrar el cajón ni perder el foco. */
    swap(doc) {
      const openState = {};
      this.root.querySelectorAll('details[id]').forEach(d => { openState[d.id] = d.open; });
      const focusId = document.activeElement && this.root.contains(document.activeElement) ? this.keyOf(document.activeElement) : null;
      const drawerBody = this.root.querySelector('.pa-col-dform');
      const scroll = drawerBody ? drawerBody.scrollTop : 0;

      const freshRoot = doc.querySelector('[data-pa-col]') || doc;
      this.root.querySelectorAll('[data-pa-col-region]').forEach(region => {
        const fresh = freshRoot.querySelector(`[data-pa-col-region="${region.dataset.paColRegion}"]`);
        if (fresh) region.innerHTML = fresh.innerHTML;
      });

      this.root.querySelectorAll('details[id]').forEach(d => { if (d.id in openState) d.open = openState[d.id]; });
      if (drawerBody) drawerBody.scrollTop = scroll;
      if (focusId) {
        const el = this.findByKey(focusId);
        if (el) el.focus({ preventScroll: true });
      }
      document.dispatchEvent(new CustomEvent('pa:collection:updated', { detail: { sectionId: this.sectionId } }));
    }

    keyOf(el) {
      if (el.id) return { id: el.id };
      if (el.name) return { name: el.name, value: el.value, form: el.form ? el.form.className : '' };
      if (el.matches('[data-pa-col-bucket]')) return { bucket: el.dataset.gte + '-' + el.dataset.lte, form: el.form ? el.form.className : '' };
      return null;
    }

    findByKey(k) {
      if (k.id) return document.getElementById(k.id);
      const forms = [...this.root.querySelectorAll('form')].filter(f => f.className === k.form);
      for (const f of forms) {
        const el = k.bucket
          ? [...f.querySelectorAll('[data-pa-col-bucket]')].find(b => b.dataset.gte + '-' + b.dataset.lte === k.bucket)
          : [...f.elements].find(x => x.name === k.name && x.value === k.value);
        if (el) return el;
      }
      return null;
    }

    async loadMore(btn) {
      btn.classList.add('is-loading');
      try {
        const doc = await this.fetchDoc(btn.href);
        const grid = this.root.querySelector('[data-pa-col-grid]');
        const freshGrid = doc.querySelector('[data-pa-col-grid]');
        const tile = grid.querySelector('.pa-col-tile');
        if (grid && freshGrid) {
          const items = [...freshGrid.querySelectorAll(':scope > li:not(.pa-col-tile)')];
          items.forEach(li => grid.appendChild(li));
          const firstLink = items[0] && items[0].querySelector('a[href]:not([tabindex="-1"])');
          if (firstLink) firstLink.focus({ preventScroll: true });
        }
        if (tile) grid.appendChild(tile);
        const end = this.root.querySelector('[data-pa-col-end]');
        const freshEnd = doc.querySelector('[data-pa-col-end]');
        if (end && freshEnd) end.innerHTML = freshEnd.innerHTML;
      } catch (err) {
        if (err.name !== 'AbortError') window.location.href = btn.href;
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }

  ready(() => {
    document.querySelectorAll('[data-pa-col]').forEach(root => {
      if (!root.paCollection) root.paCollection = new PaCollection(root);
    });
  });
})();
